
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { authService } from '@/auth/AuthServiceInst'
import HelperModal from '@/components/Modals/HelperModal.vue'
import BreadCrumb from '@/components/Breadcrumb/Breadcrumb.vue'

@Component({
  components: {
    HelperModal,
    BreadCrumb
  }
})
export default class AppBar extends Vue {
  public familyName: string = ''
  public givenName: string = ''
  public avatarName: string = ''

  mounted () {
    this.familyName = authService.getDecodedToken().family_name
    this.givenName = authService.getDecodedToken().given_name
    this.avatarName = this.familyName.charAt(0) + this.givenName.charAt(0)
  }
}
